// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IAccountCloseDetailsReportDto,
  IClosesByAccountReportDto,
  IErrorDto,
  IGenericErrorDto,
  IListOfAccountsReportDto,
  IStatusDto,
} from '../models/index';
import {
    IAccountCloseDetailsReportDtoFromJSON,
    IAccountCloseDetailsReportDtoToJSON,
    IClosesByAccountReportDtoFromJSON,
    IClosesByAccountReportDtoToJSON,
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IGenericErrorDtoFromJSON,
    IGenericErrorDtoToJSON,
    IListOfAccountsReportDtoFromJSON,
    IListOfAccountsReportDtoToJSON,
    IStatusDtoFromJSON,
    IStatusDtoToJSON,
} from '../models/index';

export interface GetAccountCloseDetailsReportRequest {
    accountId: number;
    closeDate: string;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetClosesByAccountRequest {
    accountId: number;
    startDate?: string;
    endDate?: string;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetListOfAccountsReportRequest {
    closeDay?: string;
}

/**
 * ReconciliationServiceServiceApi - interface
 * 
 * @export
 * @interface ReconciliationServiceServiceApiInterface
 */
export interface ReconciliationServiceServiceApiInterface {
    /**
     * 
     * @summary Get report of account close details
     * @param {number} accountId 
     * @param {string} closeDate 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported. Example: sentToPartnerOn,desc; id, transactionDate, confirmedByPartnerOn
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReconciliationServiceServiceApiInterface
     */
    getAccountCloseDetailsReportRaw(requestParameters: GetAccountCloseDetailsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAccountCloseDetailsReportDto>>;

    /**
     * Get report of account close details
     */
    getAccountCloseDetailsReport(requestParameters: GetAccountCloseDetailsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAccountCloseDetailsReportDto>;

    /**
     * 
     * @summary Get report of closes by account
     * @param {number} accountId 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported. Example: reconClose.endDate,desc; reconClose.id; reconClose.startDate; reconClose.endDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReconciliationServiceServiceApiInterface
     */
    getClosesByAccountRaw(requestParameters: GetClosesByAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClosesByAccountReportDto>>;

    /**
     * Get report of closes by account
     */
    getClosesByAccount(requestParameters: GetClosesByAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClosesByAccountReportDto>;

    /**
     * 
     * @summary Get report of all root accounts prior close day
     * @param {string} [closeDay] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReconciliationServiceServiceApiInterface
     */
    getListOfAccountsReportRaw(requestParameters: GetListOfAccountsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IListOfAccountsReportDto>>;

    /**
     * Get report of all root accounts prior close day
     */
    getListOfAccountsReport(requestParameters: GetListOfAccountsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IListOfAccountsReportDto>;

    /**
     * 
     * @summary Get all existing Statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReconciliationServiceServiceApiInterface
     */
    getStatusesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IStatusDto>>;

    /**
     * Get all existing Statuses
     */
    getStatuses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IStatusDto>;

}

/**
 * 
 */
export class ReconciliationServiceServiceApi extends runtime.BaseAPI implements ReconciliationServiceServiceApiInterface {

    /**
     * Get report of account close details
     */
    async getAccountCloseDetailsReportRaw(requestParameters: GetAccountCloseDetailsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAccountCloseDetailsReportDto>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getAccountCloseDetailsReport().'
            );
        }

        if (requestParameters['closeDate'] == null) {
            throw new runtime.RequiredError(
                'closeDate',
                'Required parameter "closeDate" was null or undefined when calling getAccountCloseDetailsReport().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['accountId'] != null) {
            queryParameters['account_id'] = requestParameters['accountId'];
        }

        if (requestParameters['closeDate'] != null) {
            queryParameters['close_date'] = requestParameters['closeDate'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/account-close-details`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IAccountCloseDetailsReportDtoFromJSON(jsonValue));
    }

    /**
     * Get report of account close details
     */
    async getAccountCloseDetailsReport(requestParameters: GetAccountCloseDetailsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAccountCloseDetailsReportDto> {
        const response = await this.getAccountCloseDetailsReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get report of closes by account
     */
    async getClosesByAccountRaw(requestParameters: GetClosesByAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClosesByAccountReportDto>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getClosesByAccount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['accountId'] != null) {
            queryParameters['account_id'] = requestParameters['accountId'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['end_date'] = requestParameters['endDate'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/closes-by-account`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClosesByAccountReportDtoFromJSON(jsonValue));
    }

    /**
     * Get report of closes by account
     */
    async getClosesByAccount(requestParameters: GetClosesByAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClosesByAccountReportDto> {
        const response = await this.getClosesByAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get report of all root accounts prior close day
     */
    async getListOfAccountsReportRaw(requestParameters: GetListOfAccountsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IListOfAccountsReportDto>> {
        const queryParameters: any = {};

        if (requestParameters['closeDay'] != null) {
            queryParameters['close_day'] = requestParameters['closeDay'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/list-of-accounts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IListOfAccountsReportDtoFromJSON(jsonValue));
    }

    /**
     * Get report of all root accounts prior close day
     */
    async getListOfAccountsReport(requestParameters: GetListOfAccountsReportRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IListOfAccountsReportDto> {
        const response = await this.getListOfAccountsReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all existing Statuses
     */
    async getStatusesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IStatusDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/enums/statuses`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IStatusDtoFromJSON(jsonValue));
    }

    /**
     * Get all existing Statuses
     */
    async getStatuses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IStatusDto> {
        const response = await this.getStatusesRaw(initOverrides);
        return await response.value();
    }

}
